import { LocationConnectionStatus } from '../share/enums/locationConnectionStatus';

export class TerminalConnectivityStatusReport {
  public terminalId: number;
  public lastUpdateTimeStamp: Date;
  public terminalName: string;
  public terminalCity: string;
  public locationConnectionStatus: LocationConnectionStatus;
  public comment: string;
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/terminal-connectivity-status-report/terminal-connectivity-status.type.ts